<div class="modal">
  <div id="topOfTheModal" class="modal__wrapper">
    <div class="close" (click)="onCloseModalClick()">
      <span class="icon icon_cross-light"></span>
    </div>
    <div
      [ngClass]="{
        'pb-b':
          store.showOffer ||
          store.showDecline ||
          store.showException ||
          store.showCoapplicant || store.showPartnerDown,
        'pb-s': store.showMainBlock || store.showDentistSelect && !showDentistHeader
      }"
      class="modal__header p-b-lg-big"
    >
      <div class="header__logo">
        <span class="headerIconSquare icon icon_large icon_square-logo"></span>
      </div>
      <span
        class="
          topNaming
          header-xs-big header-lg-large
          font-weight-bold font-color-gray
        "
        [ngClass]="calcTopNamingClass()"
        [innerHTML]="store.topNaming"
      ></span>
      <!-- <span *ngIf="breakpoints.extraSmall && showSelectBlock" class="showAddCoappText2 header-lg-large font-weight-bold font-color-gray"
            >Enter the information below to view loan offers <br>through iCreditWorks</span> -->
    </div>
    <div style="position: relative;">
    <app-modal-options-main
      (showOffers)="loadOffers($event)"
      [showLoader]="store.loading"
      [isMobileVerification]="userStateService.mobileCounter === 3"
      (toggleLoader)="toggleLoader($event)"
      [isCreditFreeze]="store.showCreditLock"
      [isMobileVerification]="store.showMobileValidation"
      [isWelcomeBack]="store.showWelcomeBack"
      [isMultiLoan]="store.showMultiLoan"
      [isWelcomeBackContinue]="store.showWelcomeBackContinue"
      [lastSessionDate]="store.lastSessionDate"
      [isHawaiiMessage]="store.showHawaiiMessage"
      [isDentistSelectBlock]="store.showDentistSelect"
      (closeModal)="closeModalEvent($event)"
      [hooverPopupText]="hooverPopupText"
      [FULL_DEV]="store.FULL_DEV"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      (dataSubmited)="onSubmitEvent($event)"
      (showLock)="requestHandler.showCreditLockClick()"
      *ngIf="store.showMainBlock "
    ></app-modal-options-main>

    <app-modal-options-straight-decline
      (toggleLoader)="toggleLoader($event)"
      [mobileNumber]="store.mobile"
      (closeModalEvent)="closeModalEvent($event)"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      *ngIf="store.showDecline"
    ></app-modal-options-straight-decline>

    <app-modal-options-excepton-flow
      (toggleLoader)="toggleLoader($event)"
      [mobileNumber]="store.mobile"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      *ngIf="store.showException"
      (sendAppLinkEvent)="sendAppLink($event)"
    ></app-modal-options-excepton-flow>

    <app-modal-options-partner-down
      *ngIf="store.showPartnerDown"
      (toggleLoader)="toggleLoader($event)"
      (closeModalEvent)="closeModalEvent($event)"
      [mobileNumber]="store.mobile"
    ></app-modal-options-partner-down>

    <app-modal-options-dentist-select
      *ngIf="store.showDentistSelect"
      [dentistData]="store"
      [breakpoints]="breakpoints"
      (selectDentist)="selectDentist($event)"
      (showDentistTitle)="showDentistTitle($event)"
    ></app-modal-options-dentist-select>
    
    <app-modal-options-loan-select
      (toggleLoader)="toggleLoader($event)"
      [mobileNumber]="store.mobile"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      *ngIf="store.showSelectBlock"
      [offers]="store.offersInfo"
      [isPartialApproved]="store.isPartialApproved"
      [approvedLoanAmount]="store.approvedLoanAmount"
      [maxApprovedLoanAmount]="store.maxApprovedLoanAmount"
      [loanAmount]="store.loanInfo?.amount"
      (selectedOffer)="onOfferInfo($event)"
    ></app-modal-options-loan-select>

    <app-modal-options-offer
      (toggleLoader)="toggleLoader($event)"
      [mobileNumber]="store.mobile"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      [offerInfo]="store.selectedOfferInfo"
      (sendAppLinkEvent)="sendAppLinkAndShowSuccess($event)"
      [loanAmount]="store.loanInfo?.amount"
      *ngIf="store.showOffer"
    ></app-modal-options-offer>

    <app-modal-options-credit-lock
      (toggleLoader)="toggleLoader($event)"
      [breakpoints]="breakpoints"
      (closeModal)="closeModalEvent($event)"
      [loanData]="store.loanData"
      [dev]="store.FULL_DEV"
      (unlock)="unlockCreditFreeze($event)"
      *ngIf="store.showCreditLock"
    ></app-modal-options-credit-lock>

    <app-modal-options-success
      *ngIf="store.showSuccess"
      (toggleLoader)="toggleLoader($event)"
      [breakpoints]="breakpoints"
      (closeModal)="closeModalEvent($event)"
    ></app-modal-options-success>

    <app-modal-options-add-coapplicant
      [approvedLoanAmount]="store.approvedLoanAmount"
      (toggleLoader)="toggleLoader($event)"
      [mobileNumber]="store.mobile"
      [breakpoints]="breakpoints"
      [loanAcctId]="store.loanAcctId"
      *ngIf="store.showCoapplicant"
      (sendAppLinkEvent)="sendAppLinkAndShowSuccess($event)"
      [loanAmount]="store.loanInfo?.amount"
      [offersInfo]="store.selectedOfferInfo"
    ></app-modal-options-add-coapplicant>

    <app-modal-options-partial-approved
      *ngIf="store.showPartialApproved"
      (toggleLoader)="toggleLoader($event)"
      (showSelectEvent)="showSelectEvent($event)"
      [approvedLoanAmount]="store.approvedLoanAmount"
      [loanAmount]="store.loanInfo.amount"
      [breakpoints]="breakpoints"

    ></app-modal-options-partial-approved>

    <app-modal-options-error
      [breakpoints]="breakpoints"
      (closeError)="closeErrorScreen()"
      (closeModal)="closeModalEvent($event)"
      *ngIf="store.showErrorScreen"
    ></app-modal-options-error>

    <!-- <div class="loader__wrapper" *ngIf="store.loading">
      <div class="loader"></div>
    </div> -->
  </div>
</div>
</div>
